import { render, staticRenderFns } from "./MinimumQuantityList.vue?vue&type=template&id=6f08a8c3&"
import script from "./MinimumQuantityList.vue?vue&type=script&lang=js&"
export * from "./MinimumQuantityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports